import LinkButton from '../../../utils/LinkButton';

export default function IntroSection() {
  return (
    <section className="text-center py-8 px-4 max-w-2xl mx-auto">
      <h2 className="text-[30px] lg:text-[43px] font-bold">
        Pay easy, Live better
      </h2>
      <p className="text-xl text-gray-600 mt-2">
        Experience the convenience of paying in instalments for everything you
        need, from electronics to lifestyle essentials and a cozy home.
      </p>
      <div className="mb-10 lg:mb-0 my-4">
        {/* <CustomButton text="Learn more" className="w-[50%] lg:w-[30%]" /> */}
        <LinkButton link="/how-it-works">Learn more</LinkButton>
      </div>
    </section>
  );
}
